export const hasClaim = (
  userClaims: string[],
  claimsToCheck: string[]
): boolean => {
  return (
    userClaims.find((claim) => claimsToCheck.includes(claim)) !== undefined
  );
};
